module.exports = __webpack_public_path__ + "img/5.77748571.jpg";